import React, { useState, useRef, useEffect } from 'react';
import './SaveButton.css';

const SaveButton = ({ onSave, currentChartId, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const handleSaveAsNew = () => {
    onSave({ saveAsNew: true });
    setIsOpen(false);
  };

  const handleOverwrite = () => {
    onSave();
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const mainActionText = currentChartId ? '上書き保存' : '新規保存';
  const mainActionHandler = currentChartId ? handleOverwrite : handleSaveAsNew;

  if (!currentChartId) {
    return (
      <button
        onClick={mainActionHandler}
        className="sidePanelButton btnPrimary save-button-single"
        disabled={disabled}
        title={disabled ? "保存するにはログインが必要です" : "新しいチャートとして保存"}
      >
        {mainActionText}
      </button>
    );
  }

  return (
    <div className="save-button-container" ref={containerRef}>
      <button
        onClick={mainActionHandler}
        className="sidePanelButton btnPrimary save-button-main"
        disabled={disabled}
        title={disabled ? "保存するにはログインが必要です" : "現在のチャートを上書き保存"}
      >
        {mainActionText}
      </button>
      <button
        className="sidePanelButton btnPrimary save-button-dropdown-toggle"
        onClick={() => setIsOpen(!isOpen)}
        disabled={disabled}
        aria-haspopup="true"
        aria-expanded={isOpen}
      >
        <span className="dropdown-arrow" />
      </button>
      {isOpen && (
        <div className="save-button-dropdown">
          <ul>
            <li onClick={handleSaveAsNew}>
              新規保存
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default SaveButton;
